import React, { Component } from 'react';
import DovizKur from './../components/dovizkur';
import AltinKur from './../components/altinkur';
import CryptoKur from './../components/cryptokur';
import Bant from './../components/bant';
import http from "./../services/httpService";
import config from "./../config.json";
import $ from 'jquery';

class AnaSayfa extends Component {
  state = {  
    avalues: [],
    dvalues:  [],
    banner:{},
    mainbanner:{},
}

componentDidMount(){
    this.setValues();
    this.setBanners();

    this.interval = setInterval(() => this.setValues(), 2000);
    document.title = "Altınkaynak Şirketler Grubu - Canlı Döviz & Altın Bilgileri"

    var advHeight = 548;
        if (window.width < 973) {
            advHeight = $("#adv-img").height();
        }

        $("#adv").animate({
            height: advHeight
        }, 2000, function () {
            $("#close").css('opacity', '1');
            setTimeout(function () { 
              if ($("#adv").height() !== 0) {
                  closeAdv();
              }
          }  , 7000 )
        });

        $("#close").click(function () {
        closeAdv();
    });
}

componentWillUnmount() {
    clearInterval(this.interval);
}


async setBanners(){
  var {data : banner} =  await http.get(config.apiEndpoint + 'Banner');
  localStorage.setItem('banner', JSON.stringify(banner));

  this.setState({banner})

  var {data : mainbanner} =  await http.get(config.apiEndpoint + 'MainBanner');
  localStorage.setItem('mainbanner', JSON.stringify(mainbanner));

  this.setState({mainbanner})
}

async setValues(){

    if(JSON.parse(localStorage.getItem('avalues')) !== null){
      this.setState({avalues:JSON.parse(localStorage.getItem('avalues')),dvalues:JSON.parse(localStorage.getItem('dvalues')),banner:JSON.parse(localStorage.getItem('banner'))})
    }
    
    var {data : avalues} =  await http.get(config.restEndpoint + 'Gold');
    localStorage.setItem('avalues', JSON.stringify(avalues));
    var {data : dvalues} =  await http.get(config.restEndpoint + 'Currency');
    localStorage.setItem('dvalues', JSON.stringify(dvalues));

    if(avalues !== null & dvalues !== null)
      this.setState({avalues,dvalues})
}

showBanner = banner =>{
  if (banner !== null)
    return <a href={banner.Link} target="_blank" rel="noreferrer"><img className="banner" src={'https://www.altinkaynak.com/resources/livebanners/' + banner.Name} alt={banner.Name} /></a>
  else
    return ''
}

showMainBanner = mainbanner =>{
  if (mainbanner !== null && $.isEmptyObject(mainbanner) === false)
    return <div id="adv" className="row" style={{height:0}}><a href={mainbanner.Link} target="_blank" rel="noreferrer"><img id="adv-img" alt="reklam" src={'https://www.altinkaynak.com/resources/livebanners/top/' + mainbanner.Name} /></a><img id="close" src="img/close.png" alt="Kapat" /></div>
  else
    return ''
}

    render() { 
        return <React.Fragment>
          {this.showMainBanner(this.state.mainbanner)}
          <Bant dvalues={this.state.dvalues} avalues={this.state.avalues}/>
          <div className="row">
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-12">
                      <DovizKur main={true} webgroup={1} showdescription={false} header={'Döviz'} values={this.state.dvalues} />
                    </div>
                    <div className="col-lg-12">
                      <DovizKur main={true} group={3} goldHead={true} showdescription={true} hideValueLabels={true} header={'KG Altın'} values={this.state.dvalues}/>
                    </div>
                    <div className="col-lg-12 crypto-col">
                      <CryptoKur main={true} group={3} showdescription={false} header={'Kripto Para'} height={252}/>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-12">
                      <AltinKur main={true} groups={[2,8]} prepend={['XAUUSD']} showdescription={true} header={'Altın'} values={(this.state.avalues || []).concat(this.state.dvalues || [])}/>
                    </div>
                    <div className="col-lg-12">
                      <AltinKur main={true} group={7} prepend={['XAGUSD']} labels={{XAGUSD: 'Ons'}} silverHead={true} showdescription={true} header={'Gümüş'} values={(this.state.avalues || []).concat(this.state.dvalues || [])}/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="bannerbox">
                    {this.showBanner(this.state.banner)}
                  </div>
                </div>
              </div>
      </React.Fragment>;
    }
}

function closeAdv(){
  $("#close").css('opacity', '0');
  $("#adv").animate({
      height: 0
  }, 1000, function () {
      // Animation complete.
  });
}
 
export default AnaSayfa;